<template>
  <div class="wrap">
    <r-pointer :textName="`${ $t('varRecord.viewRecord') }`">
      <!-- 返回上一个页面 -->
      <a-button size="small" slot="pre_btn" @click="goBack"><i class="iconfont iconfanhui" style="font-size:14px;"></i>{{ $t('taskData.logs.back') }}</a-button>
    </r-pointer>
    <!-- 搜索 -->
    <r-search class="p_search" @on-blur="getCommValue" @on-search="commSearch(1)">
      <a-button type="primary" slot="btn" @click="clearData">{{ $t('formAbout.clear') }}</a-button>
      <div slot="senior" id="search_form">
        <a-form :form="searchFrom" @submit="handleSearch" class="senior_form" layout="inline">
          <a-row type="flex">
            <a-col :span="8">
              <a-form-item :label="`${ $t('varRecord.colTable[0]') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select v-decorator="['action']" style="width:100%;">
                  <a-select-option value="">{{ $t('formAbout.all') }}</a-select-option>
                  <!-- create 创建 edit 修改 read 获取 delete 删除 -->
                  <a-select-option value="read">Read</a-select-option>
                  <a-select-option value="create">Create</a-select-option>
                  <a-select-option value="edit">Edit</a-select-option>
                  <a-select-option value="delete">Delete</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="`${ $t('varRecord.colTable[2]') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select v-decorator="['procName']" style="width:100%;">
                  <a-select-option v-for="(item, index) in processOptions" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="`${ $t('varRecord.colTable[1]') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select v-decorator="['robotNo']" style="width:100%;">
                  <a-select-option v-for="(item, index) in robotOptions" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col :span="8">
              <a-form-item :label="`${ $t('varRecord.colTable[4]') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-range-picker style="width:100%;" v-decorator="['accessTime']" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :span="2"></a-col>
            <a-col :span="6" class="btn_gruop">
              <a-button type="primary" html-type="submit" :loading="searchLoading"> {{ $t('formAbout.searchBtn') }} </a-button>
              <a-button :style="{ marginLeft: '8px' }" @click="handleReset" > {{ $t('formAbout.clear') }} </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </r-search>
    <!-- 列表数据 -->
    <a-table :columns="columns" :dataSource="dataList" :loading="tabLoading" :pagination="pagination" rowKey="id">
      <!-- 操作 -->
      <!-- <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleDelete(record.id)">{{ $t('operation.btnDel') }}</a>
        </template>
      </span> -->
    </a-table>
  </div>
</template>

<script>
import { apiViewData } from '@/api/taskDataM'
import { apiRobot } from '@/api/robot'
import { apiProcess } from '@/api/process'
import { modalTip, tipMsg } from '@/utils/tipTools'

export default {
  data () {
    return {
      dateRange: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      // 机器人下拉
      robotOptions: [],
      // 流程下拉
      processOptions: [],
      // 搜索load
      searchLoading: false,
      // 表格load
      tabLoading: false,
      // 表格表头
      columns: [
        {
          title: this.$t('varRecord.colTable[0]'),
          dataIndex: 'action'
        },
        {
          title: this.$t('varRecord.colTable[1]'),
          key: 'agent_alias',
          customRender: (text, record) => {
            // return record.robot_name || record.robot_no || '-'
            return record.agent_alias || record.robot_no || '-'
          }
        },
        {
          title: this.$t('varRecord.colTable[2]'),
          key: 'proc_name',
          customRender: (text, record) => {
            return record.proc_name || record.proc_no || '-'
          }
        },
        {
          title: this.$t('varRecord.colTable[3]'),
          dataIndex: 'job_no',
          customRender: text => text || '-'
        },
        {
          title: this.$t('varRecord.colTable[4]'),
          dataIndex: 'access_time'
        }
        // {
        //   title: this.$t('operation.tableOperation'),
        //   key: 'operation',
        //   align: 'center',
        //   width: '15%',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      // 搜索表单实例
      searchFrom: this.$form.createForm(this),
      // 搜索入参
      senParams: {
        agentNo: '',
        procName: '',
        action: '',
        startTime: '',
        endTime: '',
        queryAll: '',
        queueName: '', // 空间名
        itemNo: '' // 数据编码
      },
      // 列表数据
      dataList: [],
      // 分页
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
        size: 'samll',
        showSizeChanger: true, // 可以改变 pageSize
        showTotal: total => `${this.$t('operation.total')} ${total} ${this.$t('operation.items')}，`,
        onChange: this.commSearch,
        onShowSizeChange: this.commSearch
      }
    }
  },
  created () {
    // console.log(this.$route.params.queueName)
    // console.log(this.$route.params.itemNo)
    this._fetchList()
    this._fetchSelect()
  },
  methods: {
    /**
     * 获取机器人/流程 下拉数据
     */
    _fetchSelect () {
      apiRobot.list().then(data => {
        this.robotOptions = [{ value: '', label: this.$t('formAbout.all') }]
        if (!data.total) return
        const list = data.items.map(item => {
          return {
            value: item.agentNo,
            label: item.agentAlias || item.agentNo
          }
        })
        this.robotOptions = [...this.robotOptions, ...list]
      })
      apiProcess.list().then(data => {
        this.processOptions = [{ value: '', label: this.$t('formAbout.all') }]
        if (!data.total) return
        const list = data.items.map(item => {
          return {
            value: `${item.id}_${item.procName}`,
            label: item.procName || item.procCode
          }
        })
        this.processOptions = [...this.processOptions, ...list]
      })
    },
    /**
     * 获取列表数据
     */
    _fetchList () {
      this.senParams.queueName = this.$route.params.queueName
      this.senParams.itemNo = this.$route.params.itemNo
      this.tabLoading = true
      apiViewData.viewLogs(this.senParams, this.pagination.current, this.pagination.pageSize).then(data => {
        this.tabLoading = false
        this.searchLoading = false
        this.dataList = data.hits
        this.pagination.total = data.total
      })
    },
    /**
     * 获取普通搜索值
     */
    getCommValue (searchValue) {
      this.senParams.queryAll = searchValue
    },
    /**
     * 普通搜索
     */
    commSearch (page, size) {
      this.pagination.current = page
      if (size) {
        this.pagination.pageSize = size
      }
      this._fetchList()
    },
    /**
     * 创建时间
     */
    onCreatedChange (date, dateArr) {
      this.senParams.accessTime = dateArr
    },
    /**
     * 高级搜索
     */
    handleSearch  (e) {
      e.preventDefault()
      this.searchLoading = true
      this.searchFrom.validateFields((err, values) => {
        if (!err) {
          this.senParams.procName = values['procName'] ? values['procName'].split('_')[1] : ''
          this.senParams.action = values['action'] || ''
          this.senParams.robotNo = values['robotNo'] || ''
          console.debug(values['accessTime'])
          const time = values['accessTime'] || []
          this.senParams.startTime = time[0] ? time[0].format('YYYY-MM-DD') : ''
          this.senParams.endTime = time[1] ? time[1].format('YYYY-MM-DD') : ''
          this.pagination.current = 1
          this._fetchList()
        }
      })
    },
    /**
     * 高级搜索表单清空
     */
    handleReset () {
      this.searchFrom.resetFields()
      // this.dateRange = []
      // Object.keys(this.senParams).forEach(item => {
      //   this.senParams[item] = ''
      // })
    },
    /**
     * 删除
     */
    handleDelete (id) {
      const _this = this
      this.$confirm({
        title: this.$t('operation.tip'),
        content: this.$t('process.delTip'),
        okType: 'danger',
        onOk () {
          apiViewData.delete(id).then(data => {
            _this.$message.success(this.$t('msg.delSuceess'))
            _this.commSearch(1)
          })
        }
      })
    },
    /**
     * 清空访问记录
     */
    clearData () {
      const _this = this
      modalTip(
        'confirm',
        `${this.$t('varRecord.isClear')}`,
        () => {
          apiViewData.clear({
            queueName: _this.$route.params.queueName
          }).then(data => {
            tipMsg('success', _this.$t('msg.clearOk'))
            _this.commSearch(1)
          }).catch(err => {
            console.log(err)
          })
        }
      )
    },
    /**
     * 返回前一页
     */
    goBack () {
      const _this = this
      this.$confirm({
        title: this.$t('operation.tip'),
        content: this.$t('taskData.logs.isBack'),
        okType: 'danger',
        onOk () {
          _this.$router.back()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  padding: 0 24px 12px 12px;
  background: #fff;
  .p_search {
    margin: 9px 0;
  }
  .r_status {
    i {
      margin-right: 12px;
    }
    .ing {
      color: #52C41A;
    }
    .out {
      color: #F5222D;
    }
  }
  .btn_group {
    margin-top: 20px;
    button {
      margin-right: 10px;
    }
  }
}
.file_icon {
  cursor: pointer;
  color: #4977FC;
  margin-left: 10px;
}
.f_item {
  width: 50%;
}
.ant-row {
  margin-top: 5px;
  width: 100%;
}
.ant-form-item-label {
  text-align: left;
}
</style>
